import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { message } from 'antd';

import { useStores } from '@/hooks/use-stores';

const useAlertsList = alerts => {
  const { alertStore } = useStores();
  const { t } = useTranslation();
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [isPartSelected, setIsPartSelected] = useState(false);

  useEffect(() => {
    if (alertStore.selectedAlerts.length === 0) {
      setIsPartSelected(false);
      setIsAllSelected(false);
    } else if (alertStore.selectedAlerts.length === alerts.length) {
      setIsPartSelected(false);
      setIsAllSelected(true);
    } else {
      setIsPartSelected(true);
      setIsAllSelected(false);
    }
  }, [alertStore.selectedAlerts.length]);

  const onSelectAll = () => {
    if (alertStore.selectedAlerts.length === alerts.length) {
      alertStore.resetSelectedAlerts();
    } else {
      alerts.forEach(alert => {
        if (!alert.isSelected) {
          alert.isSelected = true;
          alertStore.addSelectedAlert(alert);
        }
      });
    }
  };

  const onClickArchiveSelected = async () => {
    const promises = [];
    alertStore.selectedAlerts.forEach(alert => {
      promises.push(
        new Promise<void>(async resolve => {
          try {
            await alertStore.archive(alert.id);
            alert.isSelected = false;
          } catch {
            message.error(`${t('archive alert failed')} ${alert.title}`);
          } finally {
            resolve();
          }
        }),
      );
    });
    await Promise.all(promises);
    alertStore.removeUnSelectedAlerts();
  };

  return { isAllSelected, isPartSelected, onSelectAll, onClickArchiveSelected };
};

export default useAlertsList;
